import * as fromGetEmployeeDetailActions from './employee-detail.actions';
import * as fromGetDeceasedActions from './deceased.actions';
import * as fromBlockedActions from './block.actions';
import * as fromGetLockActions from './locked.actions';
import * as fromGenerateOtpActions from './generate-otp.actions';
import * as fromApproveFICAActions from './approve-fica.actions';
import * as fromUserRemovedActions from './remove-user.actions';
import * as fromUserRoleActions from './user-role.actions';
import * as fromGetGovIdActions from './government-id.actions';
import * as fromSelfieActions from './selfie.actions';
import * as fromApproveActions from './approve-documents.actions';
import * as fromHomeAddressActions from './home-address.actions';
import * as fromPrivacySettingsActions from './privacy-settings.actions';
import * as fromToDosActions from './to-dos.actions';
import * as fromTaxYearsActions from './tax-years.actions';
import * as fromSendTaxCertificateActions from './send-tax-certificate.actions';
import * as fromGovIdProofActions from './proof-gov-id.actions';
import * as fromOpenDocActions from './get-uploaded-doc.actions';
import * as fromTodosActions from './to-dos.actions';
import * as fromNoteActions from './note.actions';
import * as fromUpdateMobileActions from './update-mobile.actions';
import * as fromResignEmployeeActions from './resign-employee.actions';
import * as fromGroupedCustomerProductsActions from './grouped-customer-products.actions';
import * as fromGroupedProductsForSomeoneElseActions from './grouped-products-for-someone-else.actions';
import * as fromGroupedProductsFromSomeoneElseActions from './grouped-products-from-someone-else.actions';
import * as fromEmployeeWithdrawalsActions from './employee-withdrawals.actions';
import * as fromBankProofsActions from './bank-proofs.actions';
import * as botflowPlaybackActions from './botflow-playback.actions';
import * as fromProfileStatusActions from './profile-status.actions';
import * as fromBankProofDocumentsActions from './bank-proof-documents.actions';
import * as fromAddBankActions from './add-bank.actions';
import * as fromUpdateBankActions from './update-bank.actions';
import * as fromRemoveBankActions from './remove-bank.actions';
import * as fromEmployeeComplianceActions from './compliance.actions';
import * as fromEmployeeHomeAddressActions from './employee-home-address.actions';
import * as fromDeleteCustomerActions from './delete-customer.actions';
import * as fromRestoreCustomerActions from './restore-customer.actions';
import * as fromEmployeeRiskProductsActions from './employee-risk-products.actions';

//Products
export * from './current-products.actions';
export * from './archived-products.actions';

export * from './notifications.actions';

//Business Info
export * from './bi-details.actions';
export * from './employee-businesses.actions';
export * from './employee-withdrawals.actions';
export * from './bi-remove-employee.actions';
export * from './bi-update-business-details.actions';

//Bank Details
export * from './bank-details.actions';
export * from './add-bank.actions';
export * from './update-bank.actions';
export * from './remove-bank.actions';

//IFA REP
export * from './ifa-search-products.actions';
export * from './ifa-put-add-product.actions';
export * from './ifa-select-product-type.actions';

//Beneficiaries
export * from './beneficiaries.actions';

//Retirement Plan
export * from './retirement-plan.actions';

// Monthly Income
export * from './monthly-income.actions';

// Legal Documents
export * from './legal-documents.actions';

//FNA
export * from './fna.actions';

//Statements
export * from './statements.actions';
export * from './bank-proofs.actions';

// Transactions
export * from './transactions-all.actions';
export * from './filtered-transactions.actions';
export * from './transactions-failure.actions';
export * from './transactions-pending.actions';
export * from './transactions-successful.actions';

//Products For Someone Else
export * from './current-products-for-someone-else.actions';
export * from './past-products-for-someone-else.actions';
export * from './upcoming-products-for-someone-else.actions';
export * from './pending-products-for-someone-else.actions';

//Products From Someone Else
export * from './current-products-from-someone-else.actions';
export * from './past-products-from-someone-else.actions';
export * from './upcoming-products-from-someone-else.actions';
export * from './pending-products-from-someone-else.actions';
export * from './update-mobile.actions';

export * from './grouped-customer-products.actions';
export * from './grouped-products-for-someone-else.actions';
export * from './grouped-products-from-someone-else.actions';

export * from './botflow-playback.actions';
export * from './profile-status.actions';
export * from './member-detail.actions';
export * from './employee-risk-products.actions';

export {
  fromGetEmployeeDetailActions,
  fromGetDeceasedActions,
  fromBlockedActions,
  fromGetLockActions,
  fromGenerateOtpActions,
  fromApproveFICAActions,
  fromUserRemovedActions,
  fromUserRoleActions,
  fromGetGovIdActions,
  fromSelfieActions,
  fromApproveActions,
  fromHomeAddressActions,
  fromPrivacySettingsActions,
  fromToDosActions,
  fromTaxYearsActions,
  fromSendTaxCertificateActions,
  fromGovIdProofActions,
  fromOpenDocActions,
  fromTodosActions,
  fromNoteActions,
  fromUpdateMobileActions,
  fromResignEmployeeActions,
  fromGroupedCustomerProductsActions,
  fromGroupedProductsForSomeoneElseActions,
  fromGroupedProductsFromSomeoneElseActions,
  fromEmployeeWithdrawalsActions,
  fromBankProofsActions,
  botflowPlaybackActions,
  fromProfileStatusActions,
  fromBankProofDocumentsActions,
  fromAddBankActions,
  fromUpdateBankActions,
  fromRemoveBankActions,
  fromEmployeeComplianceActions,
  fromEmployeeHomeAddressActions,
  fromDeleteCustomerActions,
  fromRestoreCustomerActions,
  fromEmployeeRiskProductsActions
};
